import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.validate.js";
import "LIBS/jquery.validate.unobtrusive.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.FitGuideModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.FitGuideModal = (function (parent) {
    __extends(fitGuideModal, parent);

    /**
    * new HSN.FitGuideModal()
    **/
    function fitGuideModal() {
        this.name = 'HSN.FitGuideModal';
        fitGuideModal.__super__.constructor.call(this);

        this.internalTabsSelector = '.tab-items a[data-page-type]';
        this.externalTabsSelector = 'a[data-page-type].external-trigger';
        this.tabsSelector = this.internalTabsSelector + ',' + this.externalTabsSelector;

        setupCallbacks(this);
    }

    function setupCallbacks(scope) {
        //callback for switching tabs via external triggers
        scope.Root.on('click', scope.externalTabsSelector, function (e) {
            e.preventDefault();

            var href = $(this).attr('href');//extract trigger href ID
            href = href.substr(href.indexOf('#'));

            var tabs = $(scope.internalTabsSelector).parent();//tabs parent
            var tab = $('a[href=\"' + href + '\"]', tabs);//desired tab

            scope._tabPanel.ActivateTab(tab, false);
        });

        //Callback for tab, loading tab data
        scope.Root.on('click', scope.tabsSelector, function (e) {
            e.preventDefault();

            var selector = this;

            var data = fitGuideModal.data;//carry over data from first call

            var href = $(selector).attr('href');
            href = href.substr(href.indexOf('#'));

            data.pageType = $(selector).data("page-type");

            //retrieve tab specific data
            $.ajax(fitGuideModal.url + "?" + new Date().getTime(), {
                dataType: 'html',
                data: data,
                success: function (htmlData) {
                    $(href).html(htmlData);//fill tab content

                    if (data.pageType == 'sizeRec') {
                        //needed for unobtrusive client side validation for ajax loaded form
                        $.validator.unobtrusive.parse($('form', href));
                    }
                },
                error: function () {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                }
            });
        });

        scope.Root.on('keydown', '.exit-block .button-group .proxy-button', function (e) {
            var button = $(this);
            if (e.key === 'Enter') {
                e.preventDefault();
                button.trigger('click');
            }
            else if (e.key === 'Tab' && !e.shiftKey && button.text() === 'Save & Continue') {
                e.preventDefault();

                var elemetToFocus = scope.Close;
                scope.Center();
                scope.Content.animate({ opacity: 1 }, function () {
                    scope.SetFocus(elemetToFocus);
                });
            }
        });

        scope.Root.on('keyup', 'figure li div', function (e) {
            if (e.key === 'Tab') {                
                var parentItem = $(e.target).closest('li');                
                parentItem.find('.line').show();
            }
        });

        scope.Root.on('keydown', 'figure li div', function (e) {
            if (e.key === 'Tab') {
                var figureItems = scope.Root.find('figure li');                
                figureItems.find('.line').hide();
            }
        });
    }

    fitGuideModal.prototype._hide = function () {
    };

    /**
    * HSN.FitGuideModal#Show(url, data) -> void
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    fitGuideModal.prototype._show = function (url, data) {
        var scope = this;

        fitGuideModal.url = url;
        fitGuideModal.data = data;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: data,
            success: function (htmlData) {
                scope.Root.removeClass('loading');

                scope.DisplayModal(htmlData, 0);

                if (data.defaultPage.length > 0) {
                    var tabToSelect = $('.tab-items a[data-page-type="' + data.defaultPage + '"]', scope.Root);
                    if(tabToSelect.length) {
                        tabToSelect.trigger('click'); //set default tab based on requested tab
                    }
                    else {
                        $('.tab-items a[data-page-type]', scope.Root).last().trigger('click'); //set default tab based on fallback tab
                    }
                }
                else {
                    $('.tab-items a[data-page-type]', scope.Root).last().trigger('click'); //set default tab with no request tab.
                }
            },
            error: function () {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };


    /**
    * Submit for review modal form, use ajax to retrieve response, and update modal content
    **/
    fitGuideModal.prototype.SubmitMyMeasurementForm = function (saveData) {
        var scope = this;

        var myMeasurementForm = $('form', scope.Root);

        //manually run client validation since we arent running submit operation
        if (!myMeasurementForm.valid())
            return;

        var formData = myMeasurementForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/fitguide/submit-my-measurement?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        })
            .done(function (data) {
                var href = $('.tab-items a[data-page-type="sizeRec"]', scope.Root).attr('href');//get my measure tab
                href = href.substr(href.indexOf('#'));

                $(href).html(data);//fill tab content
            })
            .fail(function () {
                alert('error submitting my measurement values');
            });
    };

    fitGuideModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time,
            function () {
                var elemetToFocus = scope.Root.find('#modalPopup');  
                scope.Center();
                scope.Content.animate({ opacity: 1 }, function() {
                    scope.SetFocus(elemetToFocus);                                       
                });
            },
            function () {
                //scope.Center();
            });

        this._tabPanel = new HSN.TabPanel(scope.Root, scope.internalTabsSelector, null, false);
    };

    return fitGuideModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/FitGuideModal.js